// extracted by mini-css-extract-plugin
export var attachmentContainer = "_sc-0";
export var fileList = "_sc-2";
export var removeFileButton = "_sc-1";